import apiHandler from "../core/apiHandler";

const cashReportApi = apiHandler("cash/reports");

export default cashReportApi;